import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ContadorService } from 'src/app/services/contador.service';
import { TokenService } from 'src/app/token.service';

@Component({
  selector: 'app-modal-confirma-ex-contador',
  templateUrl: './modal-confirma-ex-contador.component.html',
  styleUrls: ['./modal-confirma-ex-contador.component.scss']
})
export class ModalConfirmaExContadorComponent implements OnInit {

  @Input() idContador: number;
  @Input() reload = new EventEmitter<any>();
  public isLoading: boolean = false;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private toastyService: ToastrService,
    private contadorService: ContadorService,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    this.tokenService.canActivate();
  }

  removerContador() {
    this.isLoading = true;
    this.contadorService.deleteContador( this.idContador )
    .then( data => {
      this.toastyService.success('Contador removido!');
      this.activeModal.dismiss('Cross click');
      this.reload.emit();
      this.isLoading = false;
    }).catch( err => {
      this.toastyService.error(err.error.mensagem);
      this.isLoading = false;
    }) 
  }

}
